import {ElementUtil} from '../../utils/elementUtil.js';
import {
	buildMigrationOptionFields,
	canEditMigration,
	canRetryMigration,
	canResyncMigration,
	collectMigrationOptionData,
	collectResyncOptionData,
	isMigrationRunInProgress,
	loadMigrationOptionsOntoForm,
	makeDialogButtonBar
} from './migrationOptionFields.js';

export function showMigrationEditDialog(record, migrationService, onRefresh) {
	if (!record || !record.migrationId || !canEditMigration(record)) {
		return;
	}

	var dialog = ElementUtil.create({
		tag: 'dl-dialog',
		title: 'Edit Migration',
		icon: 'vaadin:edit',
		width: .65,
		height: .75,
		listeners: {
			ready: function() {
				dialog.show();

				var showResync = canResyncMigration(record);

				var optionFields = buildMigrationOptionFields({
					includeReplaceExisting: showResync
				});
				var formPanel = ElementUtil.create({
					tag: 'dl-form-panel',
					itemid: 'form',
					children: [{
						tag: 'vaadin-form-layout',
						children: [
							{
								tag: 'vaadin-text-field',
								label: 'V6 Company Id',
								readonly: true,
								value: record.v6CompanyId || ''
							},
							{
								tag: 'vaadin-text-field',
								label: 'V6 Company Name',
								readonly: true,
								value: record.v6CompanyName || ''
							},
							{
								tag: 'vaadin-text-field',
								label: 'V8 Company',
								readonly: true,
								value: record.companyName || ''
							}
						].concat(optionFields.fields)
					}]
				});

				dialog.addToContentElement(formPanel);
				loadMigrationOptionsOntoForm(formPanel, record, optionFields);

				var inProgress = isMigrationRunInProgress(record);
				var showRetry = canRetryMigration(record) && record.migrationPhase === 'INITIAL';

				function saveOptions() {
					return migrationService.updateMigration(record.migrationId, collectMigrationOptionData(formPanel));
				}

				// Use properties.disabled — ElementUtil.setAttribute('disabled', false) still disables the button
				var buttons = [
					{
						theme: 'primary',
						properties: {disabled: inProgress},
						children: [ElementUtil.makeIcon('vaadin:check', ' Save')],
						listeners: {
							click: function() {
								if (!formPanel.isValid()) {
									window.DL.MessageUtil.showToastError('Invalid form; check values');
									return;
								}
								saveOptions().then(function() {
									window.DL.MessageUtil.showToast('Success', 'Migration options saved', {
										theme: 'success'
									});
									dialog.close();
									if (onRefresh) {
										onRefresh();
									}
								});
							}
						}
					}
				];

				if (showRetry) {
					buttons.push({
						theme: 'primary',
						style: 'margin-left: 10px;',
						properties: {disabled: inProgress},
						children: [ElementUtil.makeIcon('vaadin:rotate-right', ' Save & Retry')],
						listeners: {
							click: function() {
								if (!formPanel.isValid()) {
									window.DL.MessageUtil.showToastError('Invalid form; check values');
									return;
								}
								saveOptions().then(function() {
									return migrationService.retryMigration(record.migrationId, {});
								}).then(function() {
									window.DL.MessageUtil.showToast('Success', 'Migration retry submitted', {
										theme: 'success'
									});
									dialog.close();
									if (onRefresh) {
										onRefresh();
									}
								});
							}
						}
					});
				} else if (showResync) {
					buttons.push({
						theme: 'primary',
						style: 'margin-left: 10px;',
						properties: {disabled: inProgress},
						children: [ElementUtil.makeIcon('vaadin:refresh', ' Save & Re-Sync')],
						listeners: {
							click: function() {
								if (!formPanel.isValid()) {
									window.DL.MessageUtil.showToastError('Invalid form; check values');
									return;
								}
								// Save all options on the primary; re-sync only needs date/pull scope.
								// Note stays on the primary — the re-sync run starts with a blank note.
								saveOptions().then(function() {
									return migrationService.resyncMigration(record.migrationId, Object.assign(
										{migrationType: 'RESYNC'},
										collectResyncOptionData(formPanel),
										{note: null}
									));
								}).then(function() {
									window.DL.MessageUtil.showToast('Success', 'Re-sync submitted', {
										theme: 'success'
									});
									dialog.close();
									if (onRefresh) {
										onRefresh();
									}
								});
							}
						}
					});
				}

				buttons.push({
					theme: 'tertiary',
					style: 'margin-left: 10px;',
					innerHTML: 'Cancel',
					listeners: {
						click: function() {
							dialog.close();
						}
					}
				});

				dialog.addToContentElement(makeDialogButtonBar(buttons));
			}
		}
	});
}
